/* istanbul ignore file */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { VideoClipper } from '@bingads-webui-react/video-clipper';
import { ErrorBlock } from '@bingads-webui-campaign-react/image-experience';
import { ImageExperienceVideo } from '../../model/image-experience-video';
import { ResizedVideoView } from '../../resized-video-view';
import { CONTAINER_HEIGHT, CLIPPER_MIN_WIDTH } from '../constants';
import C from '../../constants';

export const useClipperEditor = (props) => {
  const {
    i18n,
    video,
    activityLogger,
    errors,
  } = props;

  const [clipSetting, setClipSetting] = React.useState({});
  const [isSelectionOutofSync, setIsSelectionOutofSync] = React.useState(false);

  const component = (
    <ClipperEditor
      i18n={i18n}
      video={video}
      activityLogger={activityLogger}
      errors={errors}
      onClipSettingChanged={setClipSetting}
      onSelectionOutofSync={setIsSelectionOutofSync}
    />);

  return { component, isSelectionOutofSync, getData: () => clipSetting };
};

const ClipperEditor = (props) => {
  const {
    i18n,
    video,
    activityLogger,
    errors,
    onClipSettingChanged: _onClipSettingChanged,
    onSelectionOutofSync,
  } = props;

  const onClipSettingChanged = (start, end) => {
    const newName = `Trim-[${Math.floor(start * 1000)}-${Math.floor(end * 1000)}]${video.Text ? `-${video.Text}` : ''}`;
    _onClipSettingChanged({
      start: Math.floor(start * 1000),
      end: Math.min(video.Duration, Math.floor(end * 1000)),
      name: newName,
    });
  };

  const maxWidthBasedOnRatio = C.videoAspectRatios[video.Type].ratio * CONTAINER_HEIGHT;
  const maxWidth = maxWidthBasedOnRatio < CLIPPER_MIN_WIDTH
    ? CLIPPER_MIN_WIDTH
    : maxWidthBasedOnRatio;

  return (
    <React.Fragment>
      <div className="description">
        {i18n.getString('ImageExperience_ClipperDescription')}
      </div>
      <div className="clipper-editor clip-container">
        <VideoClipper
          width={maxWidth}
          onSelectionChanged={onClipSettingChanged}
          onSelectionOutofSync={onSelectionOutofSync}
        >
          <ResizedVideoView
            thumbnailUrl={video.thumbnailUrl}
            src={video.Src}
            width={video.Width}
            height={video.Height}
            maxWidth={maxWidth}
            ratio={C.videoAspectRatios[video.Type].ratio}
            activityLogger={activityLogger}
            hideControls
          />
        </VideoClipper>
      </div>
      <ErrorBlock errors={errors} />
    </React.Fragment>);
};

ClipperEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  video: PropTypes.instanceOf(ImageExperienceVideo).isRequired,
  activityLogger: PropTypes.shape({
    signal: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
  }),
  errors: PropTypes.arrayOf(PropTypes.string),
  onClipSettingChanged: PropTypes.func.isRequired,
  onSelectionOutofSync: PropTypes.func,
};

ClipperEditor.defaultProps = {
  activityLogger: {
    signal: _.noop,
    error: _.noop,
  },
  errors: [],
  onSelectionOutofSync: _.noop,
};
